// Установка Vista на домашний экран + баннер «доступна новая версия».
//
// Зачем это первым экраном: контрибьютор снимает с телефона; приложение с
// иконкой открывается в один тап, без адресной строки (экрану съёмки достаются
// лишние ~60px) и не закрывается случайным свайпом по вкладкам.
//
// Два пути, потому что платформы не совпадают:
//   • Chrome/Android отдаёт beforeinstallprompt — рисуем одну кнопку;
//   • iOS Safari API установки не имеет вовсе — рисуем пошаговую инструкцию.
import { useState } from 'preact/hooks';
import { runInstallPrompt, useInstallMode, useUpdateAvailable } from '../pwa';
import type { T } from '../i18n';

export function UpdateBanner({ t }: { t?: T }) {
  const available = useUpdateAvailable();
  if (!available) return null;
  // Баннер виден только когда авто-релоад невозможен (идёт запись/заливка) —
  // перезагрузка посреди записи уничтожит дубль, решает человек.
  // Без t (штабной шелл) — русский, как весь штабной UI.
  return (
    <div class="strip info install-update">
      {t ? t('pwa.update.body') : 'A new version of Vista is ready.'}{' '}
      <button type="button" class="link" onClick={() => location.reload()}>
        {t ? t('pwa.update.reload') : 'Update'}
      </button>
    </div>
  );
}

export function InstallPrompt({ t }: { t: T }) {
  const mode = useInstallMode();
  const [showIOS, setShowIOS] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem('vista.install.dismissed') === '1',
  );

  if (mode === 'installed' || mode === 'unavailable' || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem('vista.install.dismissed', '1');
    setDismissed(true);
  };

  return (
    <div class="install-card wb-card">
      <div class="install-row">
        <img src="/logo/weern-mark-192.png" alt="" width="36" height="36" />
        <div class="install-text">
          <strong>{t('pwa.install.title')}</strong>
          <span class="muted">{t('pwa.install.body')}</span>
        </div>
      </div>
      <div class="row">
        {mode === 'prompt' ? (
          <button type="button" class="btn-primary" onClick={() => void runInstallPrompt()}>
            {t('pwa.install.button')}
          </button>
        ) : (
          <button type="button" class="btn-ghost" onClick={() => setShowIOS((v) => !v)}>
            {t('pwa.install.how')}
          </button>
        )}
        <button type="button" class="link" onClick={dismiss}>
          {t('pwa.install.later')}
        </button>
      </div>
      {showIOS && (
        <ol class="install-steps">
          {/* Шагов ровно три, и они называют кнопки так, как они подписаны в
              Safari — человек сверяет слово в слово. */}
          <li>{t('pwa.ios.1')}</li>
          <li>{t('pwa.ios.2')}</li>
          <li>{t('pwa.ios.3')}</li>
        </ol>
      )}
    </div>
  );
}
